import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectShowDrawer } from "../store/authentication/authSlice";

export const useDrawer = () => {
  const showDrawer = useSelector(selectShowDrawer);

  return useMemo(() => showDrawer, [showDrawer]);
};
